import { ref, computed } from "vue";

export function useSteps() {
  const currentStep = ref(1);

  const steps = [
    {
      title: "personal information",
      fields: [
        "nombres",
        "apellidos",
        "email",
        "telefonoUSA",
        "zipCode",
        "ingresosMensuales",
        "montoCredito",
      ],
    },
    {
      title: "references",
      fields: ["usReferences", "guatemalaReferences"],
    },
    {
      title: "documentation",
      fields: [
        "tipoDocumento",
        "documentoFrontal",
        "documentoTrasero",
        "comprobanteDomicilio",
        "selfie",
      ],
    },
    {
      title: "application completed",
      fields: [],
      isConfirmation: true,
    },
  ];

  const totalSteps = computed(() => steps.length);

  const nextStep = () => {
    if (currentStep.value < totalSteps.value) {
      currentStep.value++;
    }
  };

  const previousStep = () => {
    if (currentStep.value > 1) {
      currentStep.value--;
    }
  };

  const goToStep = (step) => {
    if (step >= 1 && step <= totalSteps.value) {
      currentStep.value = step;
    }
  };

  const resetSteps = () => {
    currentStep.value = 1;
  };

  return {
    currentStep,
    steps,
    totalSteps,
    nextStep,
    previousStep,
    goToStep,
    resetSteps,
  };
}
